var _mask, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmpty(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 400,
    height: 400
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 400C310.457 400 400 310.457 400 200C400 89.5431 310.457 0 200 0C89.5431 0 0 89.5431 0 200C0 310.457 89.5431 400 200 400Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200 400C310.457 400 400 310.457 400 200C400 89.5431 310.457 0 200 0C89.5431 0 0 89.5431 0 200C0 310.457 89.5431 400 200 400Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 356C296.364 340.505 356.446 323.838 380.244 306C404.043 288.162 379.327 271.495 306.098 256L262.523 263L200 356Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87 177L199.5 146L312 177L199.5 214L87 177Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.5 146C224.1 142 240.58 140 248.939 140C277.277 145.062 309.364 154.605 353 171.309C335.947 172.659 322.231 174.556 311.85 177L199.5 146Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 146C191.494 132 183.055 125 174.683 125C146.303 130.055 104.685 140.088 61 151.252C75.0213 160.727 83.6813 169.31 86.98 177L200 146Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199 356V214L312 177L308.484 306.5C301.013 313.041 286.449 321.208 264.791 331C243.133 340.792 221.203 349.125 199 356Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 356V214L87 177L90.5155 306.5C97.9867 313.041 112.551 321.208 134.209 331C155.867 340.792 177.797 349.125 200 356Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5986 235.563L87 177L200 213.796C190.96 232.359 180.246 250.094 167.858 267C144.24 259.206 117.82 248.726 88.5986 235.563Z",
    fill: "#222532",
    fillOpacity: 0.319957
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 213.236C213.667 235.711 224.833 249.633 233.5 255C277.167 239.904 316.333 224.306 351 208.204C336.234 192.769 323.184 182.367 311.85 177C289.184 184.045 251.9 196.123 200 213.236Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200 213.767C186.333 234.635 174.833 248.713 165.5 256C133.5 245.4 96.3333 229.832 54 209.296C67.6667 191.078 78.8333 180.312 87.5 177C100.833 181.306 138.333 193.562 200 213.767Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.303757,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.5 146L200 213.767L312 177L199.5 146Z",
    fill: "url(#paint9_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.664 187.94C195.583 185.542 194.503 183.195 193.427 180.899C193.2 180.415 192.623 180.206 192.139 180.433C191.656 180.66 191.447 181.236 191.674 181.72C192.747 184.008 193.822 186.347 194.9 188.736C195.12 189.223 195.693 189.44 196.18 189.22C196.667 189 196.884 188.427 196.664 187.94ZM204.664 204.94C203.583 202.542 202.503 200.195 201.427 197.898C201.2 197.415 200.623 197.206 200.139 197.433C199.656 197.66 199.447 198.236 199.674 198.72C200.747 201.008 201.822 203.347 202.9 205.736C203.12 206.223 203.693 206.44 204.18 206.22C204.667 206 204.884 205.427 204.664 204.94ZM188.928 171.572C187.751 169.203 186.578 166.896 185.408 164.65C185.161 164.176 184.576 163.992 184.102 164.239C183.628 164.486 183.444 165.071 183.691 165.545C184.856 167.78 186.024 170.075 187.194 172.433C187.432 172.911 188.013 173.107 188.491 172.869C188.97 172.631 189.165 172.05 188.928 171.572ZM180.489 155.542C179.19 153.225 177.895 150.984 176.604 148.82C176.33 148.361 175.736 148.21 175.277 148.484C174.818 148.758 174.668 149.352 174.942 149.811C176.224 151.961 177.51 154.186 178.8 156.488C179.062 156.954 179.651 157.12 180.118 156.859C180.584 156.598 180.75 156.008 180.489 155.542ZM171.106 140.033C169.634 137.795 168.166 135.658 166.702 133.621C166.39 133.187 165.786 133.088 165.352 133.399C164.918 133.711 164.818 134.316 165.13 134.75C166.578 136.765 168.031 138.881 169.489 141.097C169.783 141.543 170.383 141.667 170.829 141.373C171.276 141.079 171.4 140.479 171.106 140.033ZM160.359 125.386C158.624 123.297 156.894 121.351 155.17 119.548C154.8 119.161 154.188 119.148 153.801 119.517C153.415 119.886 153.401 120.499 153.771 120.885C155.463 122.655 157.163 124.568 158.871 126.623C159.212 127.034 159.822 127.091 160.233 126.749C160.644 126.408 160.701 125.797 160.359 125.386ZM147.506 112.445C145.35 110.706 143.203 109.195 141.064 107.912C140.605 107.637 140.011 107.786 139.736 108.244C139.461 108.703 139.61 109.297 140.068 109.572C142.129 110.808 144.203 112.267 146.291 113.951C146.707 114.287 147.316 114.221 147.651 113.805C147.987 113.389 147.922 112.78 147.506 112.445ZM131.367 103.644C128.714 102.905 126.075 102.525 123.45 102.507C122.916 102.503 122.48 102.933 122.476 103.468C122.472 104.002 122.902 104.439 123.437 104.442C125.888 104.46 128.357 104.815 130.847 105.508C131.362 105.652 131.896 105.351 132.039 104.836C132.183 104.321 131.881 103.787 131.367 103.644ZM113.04 104.36C110.651 105.236 108.281 106.421 105.93 107.914C105.479 108.201 105.345 108.799 105.632 109.25C105.918 109.701 106.516 109.835 106.968 109.548C109.204 108.127 111.45 107.004 113.706 106.177C114.208 105.993 114.466 105.437 114.282 104.935C114.098 104.433 113.542 104.176 113.04 104.36ZM97.9781 114.954C96.2674 117.168 95.008 119.558 94.2111 122.066C94.0493 122.576 94.331 123.12 94.8404 123.282C95.3498 123.444 95.8939 123.162 96.0558 122.653C96.7836 120.362 97.9367 118.173 99.5097 116.137C99.8365 115.714 99.7585 115.106 99.3356 114.779C98.9127 114.453 98.3049 114.531 97.9781 114.954ZM93.5909 132.814C94.0857 135.421 95.0364 137.966 96.399 140.346C96.6646 140.809 97.2559 140.97 97.7197 140.704C98.1835 140.439 98.3442 139.848 98.0786 139.384C96.8216 137.189 95.9467 134.847 95.4924 132.453C95.3928 131.928 94.8863 131.583 94.3612 131.683C93.8361 131.782 93.4912 132.289 93.5909 132.814ZM103.42 148.337C105.517 149.95 107.858 151.284 110.384 152.293C110.881 152.492 111.444 152.25 111.642 151.754C111.84 151.257 111.599 150.694 111.102 150.496C108.741 149.553 106.556 148.307 104.6 146.803C104.176 146.477 103.569 146.556 103.243 146.98C102.917 147.403 102.996 148.011 103.42 148.337ZM120.766 154.485C123.347 154.595 126 154.412 128.701 153.927C129.227 153.832 129.577 153.329 129.482 152.803C129.388 152.277 128.885 151.927 128.359 152.022C125.797 152.482 123.286 152.655 120.848 152.551C120.314 152.528 119.863 152.943 119.84 153.477C119.817 154.01 120.232 154.462 120.766 154.485ZM138.707 150.81C141.021 149.787 143.34 148.552 145.658 147.104C146.111 146.821 146.249 146.224 145.965 145.77C145.682 145.317 145.085 145.179 144.632 145.463C142.391 146.863 140.153 148.055 137.924 149.04C137.435 149.256 137.214 149.828 137.43 150.316C137.646 150.805 138.218 151.026 138.707 150.81ZM154.107 140.853C156.021 139.212 157.924 137.425 159.813 135.49C160.187 135.108 160.179 134.495 159.797 134.122C159.414 133.748 158.802 133.756 158.428 134.138C156.579 136.032 154.718 137.78 152.848 139.383C152.442 139.731 152.395 140.342 152.743 140.748C153.091 141.153 153.702 141.2 154.107 140.853ZM166.733 127.658C168.315 125.691 169.883 123.618 171.435 121.438C171.744 121.002 171.643 120.398 171.207 120.088C170.772 119.778 170.168 119.88 169.858 120.315C168.328 122.465 166.783 124.508 165.225 126.445C164.89 126.861 164.956 127.47 165.372 127.805C165.789 128.14 166.398 128.074 166.733 127.658ZM177.178 112.759C178.507 110.604 179.822 108.367 181.122 106.048C181.383 105.582 181.217 104.992 180.751 104.731C180.284 104.469 179.695 104.636 179.433 105.102C178.146 107.398 176.845 109.611 175.53 111.743C175.25 112.198 175.391 112.794 175.846 113.075C176.301 113.355 176.897 113.214 177.178 112.759ZM185.963 96.8874C187.096 94.6172 188.215 92.2812 189.321 89.8792C189.544 89.3937 189.332 88.8189 188.846 88.5955C188.361 88.372 187.786 88.5844 187.563 89.0699C186.465 91.4536 185.355 93.7714 184.231 96.0233C183.993 96.5015 184.187 97.0826 184.665 97.3213C185.143 97.5599 185.724 97.3656 185.963 96.8874ZM193.476 80.384C194.453 78.0369 195.418 75.6352 196.37 73.1788C196.563 72.6805 196.316 72.1199 195.817 71.9267C195.319 71.7335 194.758 71.9809 194.565 72.4792C193.619 74.9209 192.66 77.3079 191.689 79.6402C191.484 80.1336 191.717 80.7001 192.211 80.9055C192.704 81.1109 193.27 80.8774 193.476 80.384ZM199.961 63.4878C200.811 61.0871 201.65 58.6399 202.478 56.1462C202.647 55.639 202.372 55.0912 201.865 54.9228C201.357 54.7544 200.81 55.0291 200.641 55.5364C199.817 58.018 198.982 60.453 198.136 62.8415C197.958 63.3453 198.222 63.8984 198.725 64.0768C199.229 64.2553 199.782 63.9916 199.961 63.4878Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.87 32.4175C194.772 33.4713 210.587 37.4406 210.991 35.3985C211.395 33.3564 196.234 26.0761 193.332 25.0222C190.43 23.9683 187.75 24.7695 187.347 26.8116C186.943 28.8538 188.968 31.3636 191.87 32.4175Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M224.947 42.5313C222.045 41.4774 206.885 34.1971 207.288 32.155C207.692 30.1128 223.507 34.0821 226.409 35.136C229.311 36.1899 231.336 38.6997 230.933 40.7418C230.529 42.784 227.849 43.5851 224.947 42.5313Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M207.239 42.3764C211.061 43.7435 215.299 39.5039 215.919 36.4163C216.539 33.3287 213.943 29.7174 210.121 28.3503C206.3 26.9832 202.699 28.378 202.079 31.4657C201.46 34.5533 203.418 41.0093 207.239 42.3764Z",
    fill: "url(#paint13_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -71.399,
    y1: 375.345,
    x2: 380.808,
    y2: 170.601,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EEF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 342.641,
    y1: 322.384,
    x2: 170.898,
    y2: 196.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F4F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A8B9D",
    stopOpacity: 0.64
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 520.951,
    y1: 176.894,
    x2: 175.987,
    y2: 218.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#708193"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 147.908,
    y1: 158.761,
    x2: 346.535,
    y2: 149.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCCCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 33.5065,
    y1: 147.361,
    x2: 150.922,
    y2: 172.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F4F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 316.915,
    y1: 434.82,
    x2: 200.005,
    y2: 308.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94A6B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 204.873,
    y1: 172.394,
    x2: 78.9208,
    y2: 261.232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCCCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 222.234,
    y1: 205.597,
    x2: 304.669,
    y2: 255.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCCCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 133.946,
    y1: 229.742,
    x2: 93.4958,
    y2: 176.811,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCCCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 322.815,
    y1: 164.684,
    x2: 231.643,
    y2: 225.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9E2EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 185.673,
    y1: 189.437,
    x2: 160.129,
    y2: 99.1232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7A92A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 210.771,
    y1: 36.4811,
    x2: 200.414,
    y2: 19.2208,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCCCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 207.074,
    y1: 33.24,
    x2: 222.277,
    y2: 25.0543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.000237542,
    stopColor: "#F0F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCCCDC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear",
    x1: 221.024,
    y1: 45.5691,
    x2: 207.23,
    y2: 33.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D5E1ED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94A6B8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.b9680c605d50339b8ce3b1cb1a070c6b.svg";
export { ForwardRef as ReactComponent };